import { render, staticRenderFns } from "./PortfolioCard.vue?vue&type=template&id=85168636&scoped=true&"
import script from "./PortfolioCard.vue?vue&type=script&lang=js&"
export * from "./PortfolioCard.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCard.vue?vue&type=style&index=0&id=85168636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85168636",
  null
  
)

export default component.exports